import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Clock, CreditCard, Video, ShieldCheck, ArrowRight } from "lucide-react";
import { getBookingConfig } from "@/lib/api";

export default function BookingCTA() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    getBookingConfig().then(setCfg).catch(() => {});
  }, []);

  const price = cfg?.price ?? 60;
  const duration = cfg?.duration_min ?? 30;

  const perks = [
    { icon: Clock, label: `${duration} minuti dedicati` },
    { icon: Video, label: "In videocall (Google Meet)" },
    { icon: ShieldCheck, label: "Pagamento sicuro con Stripe" },
  ];

  return (
    <section id="prenota-call" aria-labelledby="booking-cta-title" className="relative py-20 sm:py-24">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-emerald-500/20 bg-gradient-to-br from-[var(--ink-950,#0b0e0d)] to-emerald-950 p-8 sm:p-12">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <p className="flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.18em] text-emerald-300">
                <CalendarClock className="h-3.5 w-3.5" /> Consulenza 1:1
              </p>
              <h2 id="booking-cta-title" className="mt-3 font-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl">
                Prenota una call di consulenza
              </h2>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/70">
                Un confronto diretto sul tuo progetto: analizziamo processi e problemi concreti e usciamo
                con una direzione chiara su cosa conviene fare e con quale investimento.
              </p>
              <ul className="mt-6 space-y-2.5">
                {perks.map((p) => (
                  <li key={p.label} className="flex items-center gap-2.5 text-sm text-white/80">
                    <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-300">
                      <p.icon className="h-4 w-4" />
                    </span>
                    {p.label}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur">
              <div className="flex items-baseline gap-2">
                <span className="font-display text-5xl font-semibold text-white">€ {price}</span>
                <span className="text-sm text-white/60">/ sessione</span>
              </div>
              <p className="mt-2 flex items-center gap-1.5 text-sm text-white/60">
                <CreditCard className="h-4 w-4" /> Paghi solo la consulenza, senza impegni successivi.
              </p>
              <Link
                to="/prenota"
                data-testid="home-book-cta"
                className="mt-6 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-white font-semibold text-emerald-800 transition-colors duration-200 hover:bg-emerald-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2 focus-visible:ring-offset-emerald-950"
                aria-label="Vai alla pagina di prenotazione della call"
              >
                Scegli data e ora <ArrowRight className="h-4 w-4" />
              </Link>
              <p className="mt-3 text-center text-xs text-white/50">
                Ricevi conferma e link alla videocall via email.
              </p>
              <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-xs font-medium text-amber-300">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-amber-300" />
                Posti limitati questo mese · max 4 progetti l'anno
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
